import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Store } from '@softline/core';
import { Modal } from '@softline/ui-core';
import { Observable } from 'rxjs';
import {
  RecentObjectsStore,
  SOFTLINE_FEATURE_TIME_REPORT_RECENT_OBJECT,
} from '../../../arbeitsbericht.shared';
import { Objekt } from '../../../models/objekt.model';

const RECENT_OBJECT_COUNT = 8;

import { LoadingSpinnerComponent, TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-arbeitsbericht-recent-objects-dialog',
  templateUrl: './recent-objects-dialog.component.html',
  styleUrls: ['./recent-objects-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, LoadingSpinnerComponent, TranslatePipe],
})
export class RecentObjectsDialogComponent implements OnInit, Modal<Objekt | undefined> {
  private store = inject(Store);
  close!: (result: Objekt | undefined) => void;

  recentObjects$: Observable<readonly Objekt[]> = this.store.observe(
    SOFTLINE_FEATURE_TIME_REPORT_RECENT_OBJECT,
    RecentObjectsStore.getters.all
  );

  loading$: Observable<boolean> = this.store.observe(
    SOFTLINE_FEATURE_TIME_REPORT_RECENT_OBJECT,
    RecentObjectsStore.getters.loading
  );

  async ngOnInit(): Promise<void> {
    const queryParams = { letzenArbeitsberichte: RECENT_OBJECT_COUNT };

    await this.store.dispatch(
      SOFTLINE_FEATURE_TIME_REPORT_RECENT_OBJECT,
      RecentObjectsStore.actions.loadMany,
      { clear: true, queryParams }
    );
  }

  registerCloseHandler(handler: (result: Objekt | undefined) => void) {
    this.close = handler;
  }
}
